import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { installClientErrorReporting } from "@shared/clientErrors";
import "./styles.css";

// Uncaught errors and unhandled rejections go to POST /api/client-errors,
// grouped server-side and listed under Settings > Client errors. Installed
// before render so a crash in the first render is caught too.
installClientErrorReporting(
  "relative",
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "dev"
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the app-shell + Web Push service worker (VC-22 shell, VC-23 ring).
// Non-blocking; a failure is silent - the app works fine without it, and the
// SMS path still delivers the ring.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });

  // Fallback for the rare browser where the SW cannot `client.navigate()` a
  // focused tab: it posts the deep link back for the page to follow itself.
  navigator.serviceWorker.addEventListener("message", (event) => {
    const data = event.data as { type?: string; url?: string } | undefined;
    if (data?.type === "ring-open" && typeof data.url === "string") {
      window.location.assign(data.url);
    }
  });
}
